<script setup lang="ts">
import DropdownNotification from '@/components/Header/DropdownNotification.vue'
import { useSidebarStore } from '@/store/sidebar'

const sidebarStore = useSidebarStore()

const handleSidebarButton = () => {
  if (window.innerWidth < 1024) {
    sidebarStore.toggleSidebar()
    return
  }

  sidebarStore.toggleCollapsed()
}
</script>

<template>
  <header class="sticky top-0 z-[999] flex w-full border-b border-stroke bg-white">
    <div class="relative flex w-full items-center justify-between px-4 py-2 md:px-6 2xl:px-8">
      <div class="flex items-center gap-3">
        <button
          class="z-99999 block border border-stroke bg-white p-1.5 shadow"
          @click="
            () => {
              handleSidebarButton()
            }
          ">
          <span class="relative block h-5.5 w-5.5 cursor-pointer">
            <span class="du-block absolute right-0 h-full w-full">
              <span
                class="relative left-0 top-0 my-1 block h-0.5 w-0 bg-black delay-[0] duration-200 ease-in-out dark:bg-white"
                :class="{ '!w-full delay-300': true }"></span>
              <span
                class="relative left-0 top-0 my-1 block h-0.5 w-0 bg-black delay-150 duration-200 ease-in-out dark:bg-white"
                :class="{ 'delay-400 !w-full': true }"></span>
              <span
                class="relative left-0 top-0 my-1 block h-0.5 w-0 bg-black delay-200 duration-200 ease-in-out dark:bg-white"
                :class="{ '!w-full delay-500': true }"></span>
            </span>
          </span>
        </button>
      </div>

      <div class="ml-auto flex items-center gap-3">
        <div class="flex items-center gap-3">
          <DropdownNotification />
        </div>
      </div>
    </div>
  </header>
</template>
